import DrdAdapter from './DrdAdapter';

export default {
  __init__: [ 'drdAdapter' ],
  drdAdapter: [ 'type', DrdAdapter ]
};